import { doApi } from './apiClient';
import type {
  Match,
  TypeMatch,
  StipulationMatch,
  CreateMatchPayload,
  MatchCreateResponse,
  ConfirmWinnerPayload,
  ApiResponse,
  WrestlerTeam,
} from '../types';

export const apiGetMatch = async (): Promise<TypeMatch[]> => {
  return doApi<TypeMatch[]>('api/match/get', 'GET');
};

export const apiGetMatchById = async (id: number): Promise<Match> => {
  return doApi<Match>(`api/fight/get/${id}`, 'GET');
};

export const apiGetAllStipulation = async (typeMatch: string): Promise<StipulationMatch[]> => {
  return doApi<StipulationMatch[]>(`api/match/stipulations/${typeMatch}`, 'GET');
};

export const apiGetNumberWrestler = async (
  data: { typeMatch: string; stipulation?: string }
): Promise<{ teams: WrestlerTeam[] }> => {
  return doApi<{ teams: WrestlerTeam[] }>(
    'api/match/stipulations/getnumberwrestler/',
    'POST',
    data
  );
};

export const apiCreateMatch = async (data: CreateMatchPayload): Promise<MatchCreateResponse> => {
  return doApi<MatchCreateResponse>('api/fight/create/', 'POST', data);
};

export const apiEditMatch = async (
  data: Partial<CreateMatchPayload>,
  id: number
): Promise<MatchCreateResponse> => {
  return doApi<MatchCreateResponse>(`api/fight/edit/${id}`, 'POST', data);
};

export const apiConfirmWinner = async (
  data: ConfirmWinnerPayload
): Promise<ApiResponse<Match>> => {
  return doApi<ApiResponse<Match>>('api/fight/confirm-winner/', 'POST', data);
};

// V2 APIs

interface TypeMatchGrouped {
  type: string;
  matches: TypeMatch[];
}

export const apiGetTypeMatchesGroupedByType = async (): Promise<TypeMatchGrouped[]> => {
  return doApi<TypeMatchGrouped[]>('api/typematch/v2/all-grouped-by-type', 'GET');
};

export const apiGetTypeMatchesAllV2 = async (): Promise<TypeMatch[]> => {
  return doApi<TypeMatch[]>('api/typematch/v2/all', 'GET');
};

export const apiGetTypeMatchTypesV2 = async (): Promise<string[]> => {
  return doApi<string[]>('api/typematch/v2/types', 'GET');
};

export const apiCreateTypeMatchV2 = async (
  data: Omit<TypeMatch, 'id'>
): Promise<ApiResponse<TypeMatch>> => {
  return doApi<ApiResponse<TypeMatch>>('api/typematch/v2/create', 'POST', data);
};

export const apiCreateMatchV2 = async (data: CreateMatchPayload): Promise<MatchCreateResponse> => {
  return doApi<MatchCreateResponse>('api/match/v2/create', 'POST', data);
};

export const apiEditMatchV2 = async (
  data: Partial<CreateMatchPayload>,
  id: number
): Promise<MatchCreateResponse> => {
  return doApi<MatchCreateResponse>(`api/match/v2/edit/${id}`, 'PUT', data);
};

export const apiDeleteMatchV2 = async (id: number): Promise<ApiResponse<null>> => {
  return doApi<ApiResponse<null>>(`api/match/v2/delete/${id}`, 'DELETE');
};
